<template>
  <div class="mx-3" style="page-break-inside: avoid; padding-bottom: 1em">
    <hr style="margin-top: 2em">
    <div class="row">
      <div class="col-9">
          <h2 class="pl-1" style="font-size: 1.2em; font-weight: bold">
              <img
                  :src="getImageSource(sign.sign)"
                  height="35px"
                  alt=""
                  style="margin-right: 1em"
              >
              {{ signObj.name }}
          </h2>
      </div>
      <div class="col-3 d-flex justify-content-end">
          <button class="btn btn-sm btn-danger form-button hidden" @click="$emit('remove', sign.id)">
              {{ $t('observations.remove_from_report')}}
          </button>
      </div>
    </div>
    <div v-if="sign.info">
      <span
        class="item-detail-text"
        style="font-size: 1em; color: #636364; margin-bottom: .5em"
      >{{ sign.info ? sign.info : '' }}</span>
    </div>
    <div
      v-if="sign.photos.length > 1 && showAllPhotos"
      class="row nopads"
    >
      <div
        v-for="(photo, index) in sign.photos"
        :key="index"
        class="col-6 pb-2 multi-img-row"
      >
        <div class="image-container">
          <ImageView
            :img-size="'sm'"
            :url="getPhotoUrlForSign(signPhotoUrl, sign.id, photo)"
            :cache-photo="true"
            :cacheable-photo-id="photo.id"
            :contain="true"
            :height="'300px'"
            :control-size="'sm'"
            @image-loaded="onImageLoaded()"
          />
        </div>
      </div>
    </div>
    <div
      v-else-if="sign.photos.length > 0"
      class="nopads text-center"
    >
      <div class="col-12 nopads">
        <div class="image-container">
          <ImageView
            :img-size="'sm'"
            :url="getPhotoUrlForSign(signPhotoUrl, sign.id, sign.photos[0])"
            :cache-photo="true"
            :cacheable-photo-id="sign.photos[0].id"
            :contain="true"
            :height="'420px'"
            :control-size="'sm'"
            @image-loaded="onImageLoaded()"
          />
        </div>
      </div>
    </div>
      <div class="my-3">
          <!-- Fixed width div -->
          <div style="height: 300px; width: 730px; position: relative;">
              <map-container
                  v-if="sign"
                  :find-user="false"
                  @onMapChanged="mapMounted"
              />
              <road-sign-map
                  v-if="map"
                  ref="signMap"
                  :map="map"
                  :signs="mapItems"/>
          </div>

      </div>
      <!-- Flexible width div -->
      <div class="pt-4">
          <table class="table table-sm">
              <thead>
              <tr>
                  <th>{{ $t('observations.id') }}</th>
                  <th>{{ $t('road_sign.sign') }}</th>
                  <th>{{ $t('road_sign.value') }}</th>
                  <th>{{ $t('road_sign.created_at') }}</th>
                  <th>{{ $t('road_sign.removed_at') }}</th>
                  <th>{{ $t('contracts.name') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                  <td>{{ sign.id }}</td>
                  <td>{{ signObj.name }}</td>
                  <td>{{ sign.value }}</td>
                  <td>{{ toLocalTime(sign.created_at) }}</td>
                  <td>{{ sign.removed_at? toLocalTime(sign.removed_at) : '' }}</td>
                  <td>{{ sign.contract ? sign.contract.name : '' }}</td>
              </tr>
              </tbody>
          </table>
      </div>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import ImageView from '../view/ImageView'
import {restApi} from '../mixins/RestApiMixin'
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from '../mixins/MapMixin'
import {Pagination} from "@egjs/flicking-plugins";
import {roadSignHelper} from "../mixins/RoadSignMixin.js";
import RoadSignMap from "./RoadSignMap.vue";
import MapContainer from "../map/MapContainer.vue";

export default {
    name: 'RoadSignPrintDetails',
    components: {MapContainer, RoadSignMap, MarkerEditorMap, ImageView},
    mixins: [timeUtils, restApi, mapHelper, roadSignHelper],
    props: {
        sign: {
            type: Object,
            default() {
                return null
            }
        },
        reportCompleted: {
            type: Boolean,
            default() {
                return false
            }
        },
        showAllPhotos: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            map: null,
            mapReady: false,
            imgLoaded: 0,
            signObj: null,
            plugins: [new Pagination({type: 'bullet'})],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
        }
    },
    computed: {
        mapItems() {
            return [this.sign]
        }
    },
    watch: {
        reportCompleted(val) {
            if (val && this.mapReady) {
                this.switchMapToImage()
            }
        },
        imgLoaded: function() {
            if (this.imgLoaded === this.sign.photos.length) {
                this.$emit('loadingCompleted')
            }
        }
    },
    created() {
        if (this.sign.photos && this.sign.photos.length > 0) {
            this.$emit('loadingStarted')
        } else if (!this.sign.photos || this.sign.photos.length < 1) {
            this.$emit('loadingCompleted')
        }
        this.signObj = this.getSign(this.sign.sign)
    },
    methods: {
        getSignsMap() {
            return this.map
        },
        getPhotoUrlForSign: function (baseUrl, signId, photo) {
            return baseUrl + '/' + signId + '/' + photo.id
        },
        mapMounted(map) {
            this.map = map
            this.mapReady = true
            if (this.reportCompleted) {
                // No photos in report, give time for map to load
                setTimeout(() => this.switchMapToImage(), 3000 )
            }
            this.$nextTick(() => this.map.hideMapControls())
        },
        switchMapToImage() {
                this.$emit('readyToPrint')
        },
        onImageLoaded() {
            this.imgLoaded++
        },
    }
}
</script>

<style scoped>

.detail-map, .report-photos {
    display: block;
    height: 250px;
    width: 450px;
    overflow: hidden;
}

.detail-map {
    position: absolute;
    border-radius: 1.2em;
    border: 1px solid #BCBCBC;
}

.report-photos {
    margin-top: 210px;
}
.image-container {
    width: fit-content;
    margin: auto;
}
</style>

